import * as environments from 'src/environments.json';
import authorizeUser from 'src/auth/use-cases/authorizeUser';

const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const request = async ({ url, method, body, file, responseType }) => {
  const originalUrl = url.toString();

  if (!window.navigator.onLine) {
    alert('No está conectado a internet. Revise su conexión.');
    return;
  }

  let headers = {
    Accept: responseType === 'blob' ? '*/*' : 'application/json'
  };

  if (localStorage.accessToken) {
    headers.Authorization = `Bearer ${localStorage.accessToken}`;
  }

  if (!file && responseType !== 'blob') {
    // Para blob no imponemos application/json para no romper binarios
    headers['Content-Type'] = 'application/json';
  }

  let options = {
    method,
    headers,
    mode: 'cors'
  };

  if (body && !file) {
    options.body = JSON.stringify(body);
  } else if (file) {
    const formData = new FormData();
    formData.append('file', file);
    options.body = formData;
  }

  const fullUrl = `${env.api.url}/${url}`;
  const res = await fetch(fullUrl, options);

  // Si esperas blob, lee la respuesta como blob
  if (responseType === 'blob') {
    // Para poder seguir usando tu lógica de 401/403,
    // primero comprobamos status antes de devolver el blob.
    if (res.status === 403) {
      alert('Acceso no permitido');
      delete localStorage.accessToken;
      delete localStorage.userHeadquarterList;
      delete localStorage.selectedUserHeadquarter;
      delete localStorage.user;
      window.location = '/login';
      return;
    }

    if (res.status === 401 && localStorage.____________________) {
      const clonedResponse = res.clone();
      let errorJson = null;

      try {
        // Intentamos parsear el error como JSON por si el backend envía JSON aún siendo blob
        errorJson = await clonedResponse.json();
      } catch (e) {
        // Si no es JSON, seguimos con el flujo normal
      }

      if (errorJson?.error?.message === 'Active session not found') {
        delete localStorage.accessToken;
        delete localStorage.userHeadquarterList;
        delete localStorage.selectedUserHeadquarter;
        delete localStorage.user;
        window.location = '/login';
        return;
      }

      const { email, password } = JSON.parse(localStorage.____________________);
      const resAuthorizeUser = await authorizeUser(email, password);

      if (resAuthorizeUser.statusCode === 200) {
        // Reintentamos la llamada original, respetando responseType
        return await request({
          url: originalUrl,
          method,
          body,
          file,
          responseType
        });
      } else {
        delete localStorage.accessToken;
        delete localStorage.userHeadquarterList;
        delete localStorage.selectedUserHeadquarter;
        delete localStorage.user;
        window.location = '/login';
        return;
      }
    }

    // Si todo va bien, devolvemos el blob directamente
    const blob = await res.blob();
    return blob;
  }

  // Flujo normal JSON (tu código tal cual, con una ligera corrección de 'url' -> 'fullUrl')
  const json = await res.json();

  if (json.statusCode && json.statusCode === 403) {
    alert('Acceso no permitido');
    delete localStorage.accessToken;
    delete localStorage.userHeadquarterList;
    delete localStorage.selectedUserHeadquarter;
    delete localStorage.user;
    window.location = '/login';
    return;
  }

  if (
    json.statusCode &&
    json.statusCode === 401 &&
    localStorage.____________________
  ) {
    if (json.error?.message === 'Active session not found') {
      delete localStorage.accessToken;
      delete localStorage.userHeadquarterList;
      delete localStorage.selectedUserHeadquarter;
      delete localStorage.user;
      window.location = '/login';
      return;
    }

    const { email, password } = JSON.parse(localStorage.____________________);
    const resAuthorizeUser = await authorizeUser(email, password);

    if (resAuthorizeUser.statusCode === 200) {
      return await request({
        url: originalUrl,
        method,
        body,
        file,
        responseType
      });
    } else {
      delete localStorage.accessToken;
      delete localStorage.userHeadquarterList;
      delete localStorage.selectedUserHeadquarter;
      delete localStorage.user;
      window.location = '/login';
      return;
    }
  }

  return json;
};
/*
const request = async ({ url, method, body, file, responseType }) => {
  const originalUrl = url.toString();

  if (!window.navigator.onLine) {
    alert('No está conectado a internet. Revise su conexión.');
    return;
  }

  let headers = {
    Accept: 'application/json'
  };
  if (localStorage.accessToken) {
    headers.Authorization = `Bearer ${localStorage.accessToken}`;
  }
  if (!file) {
    headers['Content-Type'] = 'application/json';
  }

  let options = {
    method,
    headers,
    mode: 'cors'
  };

  if (body) {
    options.body = JSON.stringify(body);
  } else if (file) {
    options.body = new FormData();
    options.body.append('file', file);
  }

  url = `${env.api.url}/${url}`;

  const res = await fetch(url, options);
  const json = await res.json();

  if (json.statusCode && json.statusCode === 403) {
    alert('Acceso no permitido');
    delete localStorage.accessToken;
    delete localStorage.userHeadquarterList;
    delete localStorage.selectedUserHeadquarter;
    delete localStorage.user;
    window.location = '/login';
    return;
  }

  // Autologin when JWT is expired
  if (
    json.statusCode &&
    json.statusCode === 401 &&
    localStorage.____________________
  ) {
    if (json.error?.message === 'Active session not found') {
      delete localStorage.accessToken;
      delete localStorage.userHeadquarterList;
      delete localStorage.selectedUserHeadquarter;
      delete localStorage.user;
      window.location = '/login';
      return;
    }

    const { email, password } = JSON.parse(localStorage.____________________);

    const resAuthorizeUser = await authorizeUser(email, password);
    if (resAuthorizeUser.statusCode === 200) {
      return await request({ url: originalUrl, method, body });
    } else {
      delete localStorage.accessToken;
      delete localStorage.userHeadquarterList;
      delete localStorage.selectedUserHeadquarter;
      delete localStorage.user;
      window.location = '/login';
      return;
    }
  }

  return json;
};
*/

export default request;
